/* eslint-disable @typescript-eslint/no-explicit-any */
import { Incentive as UIIncentive, List as UIList } from '@faststore/ui'
import { useBreakpoint } from 'gatsby-plugin-breakpoints'
import Link from 'src/components/ui/Link'
import './incentives.scss'

interface Props {
  marginTop?: string
  marginBottom?: string
  icons?: [
    {
      src: string
      link: string
      title: string
      alt: string
    }
  ]
}

function Incentives({ icons, marginTop, marginBottom }: Props) {
  const { isMobile } = useBreakpoint()

  return (
    <div
      className="incentives incentives--colored layout__content-full"
      style={{ marginTop: `${marginTop}`, marginBottom: `${marginBottom}` }}
    >
      <UIList variant="unordered" className="layout__content">
        {icons?.map((icon, index) => (
          <li key={String(index)}>
            <UIIncentive>
              <Link data-incentive-content as="a" href={icon.link ?? ''}>
                <img
                  src={icon.src}
                  alt={icon.alt}
                  width={isMobile ? 18 : 24}
                  height={isMobile ? 18 : 24}
                  loading="eager"
                />
                {<p>{icon.title}</p>}
              </Link>
            </UIIncentive>
          </li>
        ))}
      </UIList>
    </div>
  )
}

export default Incentives
